export default "__VITE_ASSET__97f4e297__"